import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-three-leds',
  templateUrl: './three-leds.component.html',
  styleUrls: ['./three-leds.component.scss']
})
export class ThreeLedsComponent {
  red:string = "sec textr red";
  red1:string = "sec textr1 red1";
  blue:string = "sec textb blue";
  blue1:string = "sec textb1 blue1";
  green:string = "sec textg green";
  green1:string = "sec textg1 green1";
  @Input() set stat(val:any){
    //console.log(val);
      if(val){
     const [b, g, r] = val.split("_");
     this.red = r?this.red+" "+r:this.red+" OFF";
     this.red1 = r?this.red1+" "+r:this.red1+" OFF";

     this.green = g?this.green+" "+g:this.green+" OFF";
     this.green1 = g?this.green1+" "+g:this.green1+" OFF";

     this.blue = b?this.blue+" "+b:this.blue+" OFF";
     this.blue1 = b?this.blue1+" "+b:this.blue1+" OFF";
     
      }else{

        this.red = this.red+" OFF";
        this.red1 =this.red1+" OFF";
   
        this.green = this.green+" OFF";
        this.green1 = this.green1+" OFF";
   
        this.blue = this.blue+" OFF";
        this.blue1 =this.blue1+" OFF";
      }
  }

}
